
// eslint-disable-next-line import/prefer-default-export
export const shuffle = (array) => array.sort(() => 0.5 - Math.random());
